<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="`选择检测项目【${selectTitle}】`"
    width="900px"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <div class="table-main">
      <div class="table-header">
        <el-form ref="searchModel" :model="searchModel" label-width="auto">
          <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
            <el-col :span="9" :offset="0">
              <el-form-item prop="keyword" label="名称及编号">
                <el-input
                  v-model="searchModel.keyword"
                  placeholder="请输入"
                  clearable
                  @keyup.enter.native.stop="getItemList(true)"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="15" :offset="0">
              <el-button type="success" @click="getItemList(true)">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table
        ref="table"
        :data="tableData"
        row-key="id"
        size="small"
        stripe
        border
        height="100%"
        v-loading="tableLoading"
        @select="handleSelection"
        @select-all="handleSelectionAll"
      >
        <el-table-column type="selection" width="55" align="center" reserve-selection></el-table-column>
        <el-table-column label="序号" align="center" width="80">
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="itemCode" label="检测项目编号" width="200" align="center"></el-table-column>
        <el-table-column prop="itemName" label="检测项目" min-width="180" align="center"></el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev,sizes, pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getItemList } from '@/api/system';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectTitle: {
      type: String,
      default: ''
    },
    checkedList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      searchModel: {
        keyword: '',
        pageNum: 1,
        pageSize: 20
      },
      tableLoading: false,
      dataTotal: 0,
      tableData: [],
      activeItemList: [],
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
        this.activeItemList = [...this.checkedList];
        this.getItemList();
      }
    }
  },
  methods: {
    /******** 检测项目列表 Start ********/
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getItemList(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getItemList();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageSize = pageSize;
      this.getItemList(true);
    },
    async getItemList(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;

      this.tableLoading = true;
      const { data } = await getItemList(this.searchModel);

      this.tableData = data.list || [];
      this.tableData.map(item => {
        item.itemId = item.id;
      });
      // 绑定已选中数据
      this.$nextTick(() => {
        this.tableData.forEach(row => {
          const selected = this.activeItemList.some(activeItem => activeItem.itemId === row.itemId);
          this.$refs.table.toggleRowSelection(row, selected);
        });
      });
      this.dataTotal = data.count || 0;
      this.tableLoading = false;
    },
    /******** 检测项目列表 End ********/

    // 操作
    handleSelection(_, row) {
      const activeIndex = this.activeItemList.findIndex(item => item.itemId === row.itemId);
      activeIndex > -1 ? this.activeItemList.splice(activeIndex, 1) : this.activeItemList.push(row);
    },
    handleSelectionAll(val) {
      if (val.length > 0) {
        val.forEach(row => {
          const activeIndex = this.activeItemList.findIndex(item => item.itemId === row.itemId);
          if (activeIndex == -1) this.activeItemList.push(row);
        });
      } else {
        this.tableData.forEach(row => {
          const activeIndex = this.activeItemList.findIndex(item => item.itemId === row.itemId);
          if (activeIndex > -1) this.activeItemList.splice(activeIndex, 1);
        });
      }
    },
    async handleSubmit() {
      this.$emit('setItemList', this.activeItemList);
      this.$emit('update:visible', false);
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.table-main {
  height: 500px;
}
</style>
